import styled from 'styled-components';
import { colors, heading3, overline, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ManagePlacementsContainer = styled.div`
  @media screen and (min-width: ${pxToRem(1681)}) {
    width: ${pxToRem(1842)};
    margin: auto;
  }
`;

export const PlacementsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${spacing.base} 0;
`;

export const PageActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.base};
  align-items: center;
`;

export const Title = styled.div`
  ${heading3}
`;

export const StyledLink = styled.a`
  display: inline-block;
  margin-right: ${spacing.base};
  color: ${colors.textSecondary};

  &:hover {
    color: ${colors.textSecondary};
    text-decoration: underline;
  }
`;

export const MainBody = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: ${spacing.double} 0;
`;

export const PlacementsListContainer = styled.div`
  flex-grow: 1;
  flex-basis: 45%;
  margin-right: ${spacing.plusHalf};
  min-width: 0;
  max-width: ${pxToRem(720)}; /** Width of left-side content in Template and Campaign edit pages */
`;

export const DetailsSectionTitle = styled.div`
  ${overline}
  color: ${colors.textSecondary};
  margin-top: ${spacing.plusHalf};
`;

export const PlacementOptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};

  svg {
    width: ${spacing.double};
    height: ${spacing.plusHalf};
  }
`;

export const PlacementOptionIcon = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
